
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/logowanie-pracodawca",
      function () {
        return require("private-next-pages/logowanie-pracodawca.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/logowanie-pracodawca"])
      });
    }
  